import * as _ from 'lodash-es'
import { useContext, useEffect } from 'react'
import { GameContext } from '../GameContextF.jsx'
import { minNoPlayers } from '../../sharedF/constantsF.mts'
import { Stack, Spinner, Box } from '@chakra-ui/react'
import { Ptext } from '../../../componentsF/Chakra3F/ChakraF.jsx'

const getWaitingForNames = () => {
  const {publicStates} = useContext(GameContext)

  return _.compact(_.map(Object.values(publicStates), ({myTaskName, playerAlias}) => {
    return myTaskName == 'WaitingTask' ? null : playerAlias
  }))
}

const WaitingTaskInner = () => {
  const waitingNames = getWaitingForNames()
  const {nonBlankStacksCount, isGeneratingAiDrawings} = useContext(GameContext)

  useEffect(() => {
    window.scrollTo({ top: 0 })
    return () => {}
  }, [])

  if (isGeneratingAiDrawings) {
    return <>results will be ready in 1-2minutes!</>
  }

  if (nonBlankStacksCount < minNoPlayers) {
    return <>waiting for at least {minNoPlayers} prompts, only have {nonBlankStacksCount}</>
  }

  return <>
    waiting for {waitingNames.join(', ')}
  </>
}

export const WaitingTask = () => {
  return <Stack data-testid="waiting-state">
    {/* <PwaWrap>
      <SubGqlPushNotifsBtn>
        Notify me when it's my turn
      </SubGqlPushNotifsBtn>
    </PwaWrap> */}
    <WaitingTaskInner />
  </Stack>
}